import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const CollaborationIndicator = ({ activeUsers = [] }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(activeUsers?.length > 0);
  }, [activeUsers]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-20 right-6 z-50 bg-card border border-border rounded-lg shadow-elevated p-3 animate-fade-in">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
          <span className="text-sm font-medium text-foreground">Live Collaboration</span>
        </div>
        
        <div className="flex -space-x-2">
          {activeUsers?.slice(0, 3)?.map((user) => (
            <div
              key={user?.id}
              className={`w-8 h-8 rounded-full ${user?.color} flex items-center justify-center text-white text-xs font-medium border-2 border-surface animate-pulse-soft`}
              title={`${user?.name} is viewing this profile`}
            >
              {user?.initials}
            </div>
          ))}
          {activeUsers?.length > 3 && (
            <div className="w-8 h-8 rounded-full bg-muted-foreground flex items-center justify-center text-white text-xs font-medium border-2 border-surface">
              +{activeUsers?.length - 3}
            </div>
          )}
        </div>
        
        <Icon name="Users" size={16} className="text-muted-foreground" />
      </div>
      <div className="mt-2 text-xs text-muted-foreground">
        {activeUsers?.length === 1 
          ? `${activeUsers?.[0]?.name} is viewing this profile`
          : `${activeUsers?.length} users are viewing this profile`
        }
      </div>
    </div>
  );
};

export default CollaborationIndicator;